// TODO: cleanup with cp_trigger_accuracy_from_ui ff
export const TRIGGER_ACCURACY_FROM_UI_FF = 'cp_trigger_accuracy_from_ui';

// TODO: cleanup with cp_pick_ai_prompt_branch ff
export const PICK_AI_PROMPT_BRANCH_FF = 'cp_pick_ai_prompt_branch';

export const ACCURACY_JOBS_TAG = 'ACCURACY_JOBS';

/**
 * Job statuses the API contract guarantees the frontend can branch on: `PENDING`
 * before work starts, `EXPORTING` once accuracy numbers are generated and being
 * pushed to the dashboard, and the two terminal outcomes `COMPLETED` / `FAILED`.
 * `EXPORTING` is a contract value because cancel is rejected by the backend (409)
 * during that phase, so the UI disables Cancel on it. Every other in-flight value
 * is a pipeline stage name owned by the backend (`PHENOTYPING`, `LOADING`,
 * `ACCURACY` today) — the frontend must not enumerate those, since a stage rename
 * or addition would silently fall out of a hardcoded list. Any status not terminal
 * (see `ACCURACY_JOB_TERMINAL_STATUSES`) is treated as active.
 */
// TODO: cleanup with cp_trigger_accuracy_from_ui ff
export const ACCURACY_JOB_STATUS = {
  PENDING: 'PENDING',
  EXPORTING: 'EXPORTING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

// TODO: cleanup with cp_trigger_accuracy_from_ui ff
export const ACCURACY_JOB_TERMINAL_STATUSES = new Set<string>([
  ACCURACY_JOB_STATUS.COMPLETED,
  ACCURACY_JOB_STATUS.FAILED,
]);

// TODO: cleanup with cp_trigger_accuracy_from_ui ff
export const ACCURACY_POLL_INTERVAL_MS = 5000;

/** Matches `Batch.batch_type` on the backend — see the design doc's batch vocabulary note. */
export const TEST_BATCH_TYPE = 'Test';
export const VALIDATION_BATCH_TYPE = 'Validation';
